import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import { configurations } from './configurations';

export const initialState = {
  recommendedEventResult: [],
  eventsResult: {
    events: [],
    total: 0,
    hits: 0,
    take: 0,
    skip: 0
  },
  selectedEvent: undefined,
  eventRegistered: [],
  isFetching: false,
  isLoadingMore: false,
  error: null
};

const reducer = handleActions({
  ...mapReducersFromConfigurations('event')(configurations),
  [LOCATION_CHANGE]: (state, action) => {
    return initialState;
  }
}, {
    ...initialState
  });

export default reducer;


// WEBPACK FOOTER //
// ./src/state/modules/event/reducers.js